module.exports = __webpack_public_path__ + "banco_branco.svg?5ff00b01f0ef4643e090ff2860a5b92a";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/banco_branco.svg
// module id = 490
// module chunks = 0